import React from "react";
import PaymentMethodList from "./payment-method-list";
import classNames from "classnames";
import PropTypes from 'prop-types';

const AutoPay = ({ setAutoPay, autoPay, paymentMethod }) => (
    <>
        <div className="content-box items-start shadow-sb">
            <PaymentMethodList list={[paymentMethod]} />
        </div>
        <div className="yesno-wrapper">
            <button type="button" className={classNames(`btn text-xl btn-yesno`, { "btn-primary": autoPay }, { "btn-outline-primary": !autoPay })} onClick={() => setAutoPay(true)}>On</button>
            <button type="button" className={classNames(`btn text-xl btn-yesno`, { "btn-danger": !autoPay }, { "btn-outline-danger": autoPay })} onClick={() => setAutoPay(false)}>Off</button>
        </div>
    </>
);

AutoPay.propTypes = {
    setAutoPay: PropTypes.func.isRequired,
    autoPay: PropTypes.bool.isRequired,
    paymentMethod: PropTypes.object.isRequired
};

export default AutoPay;
